module.exports = __webpack_public_path__ + "img/keys_transfer.a9f7baa7.svg";